module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#youtube",
      toString: function () {
        return this.url;
      }
    }